import { render } from "./AddEmployees.vue?vue&type=template&id=01fc603a&scoped=true"
import script from "./AddEmployees.vue?vue&type=script&lang=js"
export * from "./AddEmployees.vue?vue&type=script&lang=js"

import "./AddEmployees.vue?vue&type=style&index=0&id=01fc603a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fc603a"]])

export default __exports__